import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment.prod';
import { AppComponent } from '../app.component';
import { ClienteModel } from './app.login.model';
import { LoginService } from './app.login.service';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {
  public cliente: ClienteModel = new ClienteModel();
  loading = false;
  returnUrl: string;
  version: string;

  constructor(public app: AppComponent,
    private authService: LoginService,
    public messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.authService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.version = environment.version;
  }


  onClickLogin(){

    try 
    { 
        this.loading = true;
        this.authService.Login(this.cliente).subscribe(data => {

        if(data.success){
          localStorage.setItem('usuarioLogado', JSON.stringify(data.data));
          console.log(data.data)
          //this.router.navigate(['/principal']);                    
          this.router.navigate([this.returnUrl]);
        }
        else
        {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message, life: 3000 });
           return;
        }
            
      },
      err => console.error(err)
      );
    }
      catch(err) {
        alert(err.message);
        this.loading = false;
      }
   }  

  // async onClickLogin() {
  //   this.loading = true;

  //   var errorCode;
  //   var errorMessage;

  //   if (String(this.usuario.usuario) == undefined) {
  //     this.messageService.add({ severity: 'error', summary: 'Informação', detail: 'Informe o E-mail!', life: 3000 });
  //     this.loading = false;
  //     return;
  //   }

  //   if (String(this.usuario.senha) == undefined) {
  //     this.messageService.add({ severity: 'error', summary: 'Informação', detail: 'Informe a Senha!', life: 3000 });
  //     this.loading = false;
  //     return;
  //   }

  //   await this.firebaseService.signin(this.usuario.usuario, this.usuario.senha).catch(function (error) {
  //     // Handle Errors here.
  //     errorCode = error.code;
  //     errorMessage = error.message;

  //     console.log(errorCode);
  //     console.log(errorMessage);
  //     // ...
  //   });
  //   if (errorCode != null) {
  //     if (errorCode.toString() == "auth/invalid-email") {
  //       this.messageService.add({ severity: 'error', summary: 'Informação', detail: 'Email não está correto!', life: 3000 });
  //       this.loading = false;
  //       return;
  //     }

  //     if (errorCode.toString() == "auth/user-not-found") {
  //       this.messageService.add({ severity: 'error', summary: 'Informação', detail: 'Usuário não encontrado na base de dados!', life: 3000 });
  //       this.loading = false;
  //       return;
  //     }

  //     if (errorCode.toString() == "auth/wrong-password") {
  //       this.messageService.add({ severity: 'error', summary: 'Informação', detail: 'A senha é inválida ou o usuário não possui uma senha!', life: 3000 });
  //       this.loading = false;
  //       return;
  //     }
  //   }

  //   if (this.firebaseService.isLoggedIn)
  //   this.router.navigate(['/']);
  // }
}
